var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgItArrowUpTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.8,12H9.2c-0.6,0-1-0.5-1-1c0-0.3,0.1-0.5,0.3-0.7L12,6.8l3.5,3.5c0.4,0.4,0.4,1,0,1.4C15.3,11.9,15.1,12,14.8,12z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItArrowUpTriangle);
export default __webpack_public_path__ + "static/media/it-arrow-up-triangle.a4fb34fe.svg";
export { ForwardRef as ReactComponent };